import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6656b2f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tiles-container"
}
const _hoisted_2 = { class: "tiles-text" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacing-10" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6 mb-1" }, "Code Acceptance Rate", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption" }, "Code accepted", -1))
const _hoisted_6 = { class: "text-h4" }
const _hoisted_7 = { class: "tiles-text" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacing-10" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6 mb-1" }, "Lines of Code Accepted", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption" }, "Code Completion", -1))
const _hoisted_11 = { class: "text-h4" }
const _hoisted_12 = { class: "tiles-text" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacing-10" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6 mb-1" }, "Documentation Requests", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption" }, "Total Requests", -1))
const _hoisted_16 = { class: "text-h4" }
const _hoisted_17 = { class: "tiles-text" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacing-10" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6 mb-1" }, "Explanation Requests", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption" }, "Total Requests", -1))
const _hoisted_21 = { class: "text-h4" }
const _hoisted_22 = { class: "tiles-text" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacing-10" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6 mb-1" }, "Test Cases Generated", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption" }, "Total Lines Suggested", -1))
const _hoisted_26 = { class: "text-h4" }
const _hoisted_27 = { class: "chart-container" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6 mb-4 text-center" }, "Code Distribution", -1))
const _hoisted_29 = {
  key: 1,
  class: "users-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_Pie = _resolveComponent("Pie")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_toolbar, {
        color: "indigo",
        elevation: "4"
      }, {
        extension: _withCtx(() => [
          _createVNode(_component_v_tabs, {
            modelValue: _ctx.tab,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
            "align-tabs": "title"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabItems, (item) => {
                return (_openBlock(), _createBlock(_component_v_tab, {
                  key: item,
                  value: item
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_toolbar_title, { class: "toolbar-title" }, {
            default: _withCtx(() => [
              _createTextVNode("nCode Metrics")
            ]),
            _: 1
          }),
          _createVNode(_component_v_spacer)
        ]),
        _: 1
      }),
      (_ctx.tab === 'overview')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_card, {
              elevation: "4",
              color: "white",
              variant: "elevated",
              class: "mx-auto my-3",
              style: {"width":"300px","height":"175px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_item, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _hoisted_3,
                      _hoisted_4,
                      _hoisted_5,
                      _createElementVNode("p", _hoisted_6, _toDisplayString(((_ctx.metrics.breakdown.completion.totalAccepted / _ctx.metrics.breakdown.completion.totalSuggested) * 100).toFixed(2)) + "% ", 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card, {
              elevation: "4",
              color: "white",
              variant: "elevated",
              class: "mx-auto my-3",
              style: {"width":"300px","height":"175px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_item, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _hoisted_9,
                      _hoisted_10,
                      _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.metrics.breakdown.completion.totalAccepted), 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card, {
              elevation: "4",
              color: "white",
              variant: "elevated",
              class: "mx-auto my-3",
              style: {"width":"300px","height":"175px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_item, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _hoisted_14,
                      _hoisted_15,
                      _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.metrics.breakdown.documentation.totalRequests), 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card, {
              elevation: "4",
              color: "white",
              variant: "elevated",
              class: "mx-auto my-3",
              style: {"width":"300px","height":"175px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_item, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _hoisted_19,
                      _hoisted_20,
                      _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.metrics.breakdown.explanation.totalRequests), 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card, {
              elevation: "4",
              color: "white",
              variant: "elevated",
              class: "mx-auto my-3",
              style: {"width":"300px","height":"175px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_item, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _hoisted_24,
                      _hoisted_25,
                      _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.metrics.breakdown.testcase.totalSuggested), 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_v_card, {
                elevation: "4",
                color: "white",
                variant: "elevated",
                class: "mx-auto my-3",
                style: {"width":"500px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_item, null, {
                    default: _withCtx(() => [
                      _hoisted_28,
                      _createVNode(_component_Pie, {
                        data: _ctx.chartData,
                        options: _ctx.chartOptions
                      }, null, 8, ["data", "options"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.tab === 'users')
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createElementVNode("h3", null, "Total Users: " + _toDisplayString(_ctx.users.length), 1),
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                  return (_openBlock(), _createBlock(_component_v_list_item, {
                    key: user.email,
                    class: "user-list-item"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, { class: "user-email" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(user.email), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_v_list_item_subtitle, { class: "user-projectid" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Project ID: " + _toDisplayString(user.projectid), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}